import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties';

export const AnalogLinkSchema = new GenericModelSchema('analogLink', {
  category: ModelCategory.ComponentDesignData,

  properties: {
    name: StringProperty,
  },
});
